import { render, staticRenderFns } from "./RulesNoMatchingSearchResult.vue?vue&type=template&id=b70bc702&scoped=true"
import script from "./RulesNoMatchingSearchResult.vue?vue&type=script&lang=js"
export * from "./RulesNoMatchingSearchResult.vue?vue&type=script&lang=js"
import style0 from "./RulesNoMatchingSearchResult.vue?vue&type=style&index=0&id=b70bc702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70bc702",
  null
  
)

export default component.exports